var exports = {
  "M": "CopyLinkSection.module__linkFooter___UGR3TE",
  "e": "CopyLinkSection.module__linkSectionLabel___UGR3TE",
};

module.exports = exports;
